import { render, staticRenderFns } from "./fa_user_view.vue?vue&type=template&id=4fc31f84&scoped=true&"
import script from "./fa_user_view.vue?vue&type=script&lang=js&"
export * from "./fa_user_view.vue?vue&type=script&lang=js&"
import style0 from "./fa_user_view.vue?vue&type=style&index=0&id=4fc31f84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc31f84",
  null
  
)

export default component.exports